import React from 'react';
import PropTypes from 'prop-types';
import { URI } from '@fiverr-private/futile/lib/url/URI';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import SafePureComponent from '../shared/SafePureComponent';

import './style.scss';

const MoreServices = (props, context) => {

    const { subCategoryName, otherNestedSubCategoryGigs, sellerName } = props;
    const { currencyConverter } = context;

    if (!otherNestedSubCategoryGigs || !otherNestedSubCategoryGigs.length) {
        return null;
    }

    return (
        <div className="more-services">
            <header>
                <h2 className="more-services-title">
                    <I18n k={'gig_page_perseus.more_services.title'}
                        params={{sub_category_name: subCategoryName || ''}}/>
                </h2>
            </header>
            <ul>
                {
                    otherNestedSubCategoryGigs.map(({serviceSlug, startPrice, serviceTypeName, serviceTypeCachedSlug}, index) => {
                        const url = new URI(`/${sellerName}/${serviceSlug}`).addParams({from_service_type_box: 'true'}).toString();

                        return (
                            <li key={index} className={`service-${serviceTypeCachedSlug}`}>
                                <p>
                                    <a href={url}>{serviceTypeName}</a>
                                    <I18n k={'gig_page_perseus.more_services.starting_at'}/> {currencyConverter.convert(startPrice)}
                                </p>
                            </li>
                        );

                    })
                }
            </ul>
        </div>
    );
};

MoreServices.propTypes = {
    subCategoryName: PropTypes.string,
    otherNestedSubCategoryGigs: PropTypes.arrayOf(
        PropTypes.shape({
            serviceSlug: PropTypes.string,
            startPrice: PropTypes.number,
            serviceTypeName: PropTypes.string,
            serviceTypeCachedSlug: PropTypes.string
        })
    ),
    sellerName: PropTypes.string
};

MoreServices.contextTypes = {
    currencyConverter: PropTypes.object
};

export { MoreServices };
export default SafePureComponent(MoreServices);
